/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from "react";

import {PackageItemItemType} from "types/enums/PackageItemItemType";
import {currencyNumberFormat, translate} from "utils/utility";
import BookingSellerReservationDetailUpsellQuantity
    from "pages/Front/Booking/Seller/BookingSellerReservationDetail/components/BookingSellerReservationDetailUpsellQuantity";
import BookingSellerReservationDetailUpsellActions
    from "pages/Front/Booking/Seller/BookingSellerReservationDetail/components/BookingSellerReservationDetailUpsellsAction";
import {useTranslation} from "react-i18next";
import {PackagesCartItem} from "types/entities/PackagesCartItem";
import {Reservation} from "types/entities/Reservation";
import SellerPackageCartItemRowCustomText
    from "pages/Front/Booking/Seller/components/SellerPackageCartItemRowCustomText";
import TableRow from "pages/Front/components/Table/TableRow";
import TableColumn from "pages/Front/components/Table/TableColumn";
import {PackageItemPersonType} from "types/enums/PackageItemPersonType";

const SellerPackageCartItemRow = (props: {packagesCartItem: PackagesCartItem; reservation: Reservation; isAccessTicket?: boolean}) => {
    const {t} = useTranslation();
    const basePrice = props.packagesCartItem.price / (props.packagesCartItem.drivers_count_adult + props.packagesCartItem.drivers_count_child);
    const discount = props.packagesCartItem.packageItem?.original_price ? 100 - (basePrice / props.packagesCartItem.packageItem.original_price) * 100 : 0;

    if (!props.packagesCartItem.packageItem?.article_id) {
        return null;
    }

    const isUpsell = props.packagesCartItem.packageItem.type == PackageItemItemType.Upsell;
    return (
        <TableRow className={"SellerPackageCartItemRow"}>
            <TableColumn>
                <div className={"flex flex-col"}>
                    <div className={"flex flex-row h-full items-center space-x-1.5 mb-1 font-medium"}>
                        <span>{props.packagesCartItem.drivers_count_adult + props.packagesCartItem.drivers_count_child}x</span>
                        {props.packagesCartItem.article_shortname && <span>{props.packagesCartItem.article_shortname}</span>}
                        {!props.packagesCartItem.article_shortname && props.packagesCartItem.packageItem && props.packagesCartItem.packageItem.name && (
                            <span>{translate(props.packagesCartItem.packageItem.name)}</span>
                        )}
                        {props.packagesCartItem.packageItem.person_type === PackageItemPersonType.Child && <small>{t("children")}</small>}
                    </div>
                    <SellerPackageCartItemRowCustomText packagesCartItem={props.packagesCartItem} reservation={props.reservation} />
                </div>
            </TableColumn>
            <TableColumn colSpan={props.isAccessTicket === true ? 2 : undefined}>
                <div className={"flex flex-row justify-start"}>
                    <BookingSellerReservationDetailUpsellQuantity reservation={props.reservation} packagesCartItem={props.packagesCartItem} />
                </div>
            </TableColumn>
            {props.isAccessTicket !== true && (
                <TableColumn className={""}>
                    {isUpsell && <BookingSellerReservationDetailUpsellActions packagesCartItem={props.packagesCartItem} reservation={props.reservation} />}
                </TableColumn>
            )}
            <TableColumn className={"text-left"}>
                {props.packagesCartItem.packageItem.original_price && currencyNumberFormat(props.packagesCartItem.packageItem.original_price)}
            </TableColumn>
            <TableColumn className={"text-left"}>{currencyNumberFormat(basePrice)}</TableColumn>
            <TableColumn className={"text-left"}>{discount ? <span>{discount.toFixed(0)} %</span> : "---"}</TableColumn>
            <TableColumn className={"text-right"}>{props.packagesCartItem.price && currencyNumberFormat(props.packagesCartItem.price)}</TableColumn>
        </TableRow>
    );
};

export default SellerPackageCartItemRow;
